export default "__VITE_ASSET__eafcdc69__"